import { render } from "./BadgeView.vue?vue&type=template&id=6492629a"
import script from "./BadgeView.vue?vue&type=script&lang=js"
export * from "./BadgeView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__